import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { loginConfig,projectConfig } from '../../environments/environment';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  public apiURL: string = projectConfig.apiURL;

  constructor(private http: HttpClient, private router: Router) { }

  login(formData: FormData): Observable<any> {
    const url = loginConfig.apiURL;
    return this.http.post(url, formData);
  }

  userRole():string{
    const user= localStorage?.getItem('user');
    if(user){
        return user;
    }
    return '';
  }
 

  logout(): void {
    localStorage.removeItem('originalTranslationData');
    localStorage.removeItem('accessToken');
    localStorage.removeItem('user');
    localStorage.removeItem('user_id');
    localStorage.removeItem('user_name');
    localStorage.clear();
    window.location.reload()
  }

  isAuthenticated(): boolean {
        const token = localStorage.getItem('accessToken');
    if (token) {
      return true;
    }
    return false;
  }

  refreshToken(): Observable<{ accessToken: any }> {
    const refresh_token = localStorage.getItem('refresh_token'); 
    return this.http.post<{ accessToken: any }>(
      `${this.apiURL}auth/refresh-token`,{refresh_token} // sending token in the request body
    );
  }
}
